// rollover
var preLoadImg = new Object();
 
function initRollOvers(){
  $("img.imgover,input.imgover").each(function(){
    var imgSrc = this.src;
    var sep = imgSrc.lastIndexOf('.');
    var onSrc = imgSrc.substr(0, sep) + '_o' + imgSrc.substr(sep, 4);
    preLoadImg[imgSrc] = new Image();
    preLoadImg[imgSrc].src = onSrc;
    $(this).hover(
      function() { this.src = onSrc; },
      function() { this.src = imgSrc; }
    );
  });
}
$(function(){
  initRollOvers();
});


// smoothScroll
var targetIdHold = jQuery(this.hash);

jQuery.easing.quart = function (x, t, b, c, d) {
  return -c * ((t = t / d - 1) * t * t * t - 1) + b;
};

jQuery(document).ready(function () {
  jQuery('a[href*="#"]').click(function () {
    let targetId = jQuery(this.hash);
    let scroll = $(window).scrollTop();

    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      let target = jQuery(this.hash);
      target = target.length && target || jQuery('[name=' + this.hash.slice(1) + ']');
      let headerH = $('#header').innerHeight();
      let adjust = 0; // ターゲット先へスクロール移動

      if (target.length) {
        let targetOffset = target.offset().top - headerH - adjust;

        jQuery('html,body').animate({
          scrollTop: targetOffset
        }, 1200, 'swing');

        return false;
      }
    }
  });
});

// 他ページからのsmoothScroll
$(function () {
  /* 現在のページURLの?anchor部分を取得
   * l-wrapにoverflow: hidden;を指定しているため、他ページからのアンカーリンクではハッシュタグを使用することができない。
   * そのため、「?anchor=id」という指定をすることで、ハッシュタグを使わずにアンカーリンクを実現する必要がある */
  let para = location.search;
  let headerH = $('#header').innerHeight();

  if (para.indexOf("?anchor=") != -1) {
    let anchor = para.split("?anchor=");
    let target = $('#' + anchor[anchor.length - 1]);

    setTimeout(function () {
      let position = target.offset().top - headerH;

      $("html, body").animate({
        scrollTop: position
      }, 1200, "swing");
    }, "1");
  }
});


// slide btn
$(function(){
  $(".js-slideBtn").each(function(index,element) {
    $(element).click(function() {
      if ( $(this).attr('data-state') == "init" || $(this).attr('data-state') == "close" ) {
        $(element).attr('data-state', 'open');
        $(element).next(".js-slidePanel").attr('data-state', 'open');
      } else {
        $(element).attr('data-state', 'close');
        $(element).next(".js-slidePanel").attr('data-state', 'close');
      }

      $(element).next(".js-slidePanel").slideToggle(250);
    });
  });
});


// header scroll settings
$(window).on('load scroll resize', function(){
  var switchLogoPos = 30;  //ヘッダーロゴの切り替えポイント
  
  var winW = $(window).width();
  var winIW = window.innerWidth;  /* スクロールバーを含む幅 */
  var header = $('#header');
  var contentTop = $('#hero');
  var gnav = $('#gnavfix');
  var logo = $('#js-hdlogo');
  var gnavBtns = $('#ganvBtn');
  var scroll = $(window).scrollTop();

  if ( scroll <= switchLogoPos ) {
    header.attr('data-scroll', 'false');
  } else {
    header.attr('data-scroll', 'true');
  }
});


//ドロワー開閉時間(CSSの設定と同一時間にする)
var drawerDuration = 500; //500 = 0.5s


// ドロワー開閉
$(function(){
  var drawer_flag = $('#drawer').attr('data-drawer');

  $("#drawerOpen").click(function () {
    drawer_flag = $('#drawer').attr('data-drawer');
    $('#drawer').attr('data-drawerprocessing', 'true'); //ドロワー処理中フラグを立てる

    if (drawer_flag == "init" || drawer_flag == "close") {
      $('#drawer').attr('data-drawer', 'open');
      $('#drawerOpen').attr('data-drawer', 'open');
    } else {
      $('#drawer').attr('data-drawer', 'close');
      $('#drawerOpen').attr('data-drawer', 'close');
    }

    drawerDuration = drawerDuration + 10; //ドロワーが開ききる直前に表示ががたつかないよう、処理時間を0.01s増やす

    setTimeout(function () {
      $('#drawer').attr('data-drawerprocessing', 'false'); //ドロワー処理中フラグを下げる
    }, drawerDuration);
  });
});


//メニュークリック
$(function(){
  $(".js-gnavLink").each(function (index, element) {
    $(element).click(function () {
      if ($('#drawer').attr('data-drawer') == 'open') {
        $('#drawer').attr('data-drawer', 'close');
        $('#drawerOpen').attr('data-drawer', 'close');
      }
    });
  });
});


$(window).on('resize', function(){
  let winIW = window.innerWidth;

  //PC時は、ドロワーはis-open、is-closeクラスを削除する
  if ( winIW >= 768 ) {
    $("#js-drawerOpen").removeClass('is-open');
    $("#drawer").removeClass('is-open');
    $("#gnav").removeClass('is-open');
    $("#js-drawerOpen").removeClass('is-close');
    $("#drawer").removeClass('is-close');
    $("#gnav").removeClass('is-close');
  }
});

//メニュークリック
$(function(){
  $(".js-gnavLink").each(function(index,element) {
    $(element).click(function() {
      if ( $("#js-drawerOpen").hasClass('is-open') ) {
        $("#js-drawerOpen").removeClass('is-open');
        $("#drawer").removeClass('is-open');
        $("#gnav").removeClass('is-open');
      }
    });
  });

  // ハッシュがあるときはオープン
  if (window.location.hash.length>0) {
    if ($(window.location.hash).next(".js-slideBox").find(".js-slideBtn").hasClass('is-active')) {
    } else {
      $(window.location.hash).next(".js-slideBox").find(".js-slideBtn").toggleClass('is-active');
      $(window.location.hash).next(".js-slideBox").find(".js-slideBtn").next(".js-slidePanel").slideToggle(300);
    }
  }
});


$(window).on('load scroll resize', function(){  
  let winW    = $(window).width();
  let winIW = window.innerWidth;        //スクロールバーを含む幅 
  let winH    = $(window).height();  //ウィンドウの高さ
  let scroll  = $(window).scrollTop();
  let fadeinitem  = $('.js-fadeinitem');
  let slideupitem  = $('.js-slideupitem');

  //要素フェードイン
  fadeinitem.each(function(){
    let fiiTop = $(this).offset().top;

    // 要素が画面の上から80%(下から20%)に来た時に動く
    let fadeinitemPos = fiiTop - (winH * 0.8);

    if (scroll > fadeinitemPos) {
      $(this).addClass("js-fadein");
    }
  });

  //要素スライドアップ
  slideupitem.each(function(){
    let suiTop = $(this).offset().top;

    // 要素が画面の上から80%(下から20%)に来た時に動く
    let slideupitemPos = suiTop - (winH * 0.8);

    if (scroll > slideupitemPos) {
      $(this).addClass("js-slideup");
    }
  });
});


//fadein
$(window).scroll(function (){
  $('.js-fadeIn').each(function(){
    var elemPos = $(this).offset().top;
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    if (scroll > elemPos - windowHeight - 30){
        $(this).addClass('js-scrollIn');
    }
  });
});




$(window).on('load scroll resize', function(){  
  let winW    = $(window).width();
  let winIW = window.innerWidth;   //スクロールバーを含む幅 
  let winIH = window.innerHeight;  //ウィンドウの高さ
  let bodyH = $('body').height(); //bodyタグの中身の高さ
  let scroll  = $(window).scrollTop();
  
  // recruitがある場合
  if ( $('#recruit').length ) {
    let recruitScaleSpeed = 0.0015;
    let recruitwrapElem  = $('#recruitwrap');
    let recruitElem  = $('#recruit');

    ///// Contact Us縮小拡大 /////
    let recruitZoomSize = 1.5;
    let recruitTranslateY = 25; //25%パーセント
    let recruitwrapTop = recruitwrapElem.offset().top;
    let recruitTriggerPos = recruitwrapTop - winIH;
  
    //ウィンドウサイズにより、縮小スピードを変える(数値が小さいほど速く縮小拡大し、数値が大きいほどゆっくり縮小拡大する)
    if (winIW < 480) {
      recruitScaleSpeed = 0.0015;
    } else if (winIW < 768) {
      recruitScaleSpeed = 0.0014;
    } else if (winIW < 1080) {
      recruitScaleSpeed = 0.0013;
    } else if (winIW < 1320) {
      recruitScaleSpeed = 0.0012;
    } else if (winIW < 1520) {
      recruitScaleSpeed = 0.0011;
    } else if (winIW < 1920) {
      recruitScaleSpeed = 0.0010;
    } else if (winIW < 2220) {
      recruitScaleSpeed = 0.0009;
    } else {
      recruitScaleSpeed = 0.0008;
    }
  
    if ( scroll >= recruitTriggerPos ) {
      recruitTranslateYTemp = recruitTranslateY - ( ( scroll - recruitTriggerPos ) * (recruitScaleSpeed * 50));
      recruitZoomSizeTemp = recruitZoomSize - ( ( scroll - recruitTriggerPos ) * recruitScaleSpeed);
      
      if (recruitTranslateYTemp <= 0) {
        recruitTranslateYTemp = 0;
      }
      if (recruitZoomSizeTemp <= 1) {
        recruitZoomSizeTemp = 1;
      }
  
      recruitElem.css({transform: 'translate(0, ' + recruitTranslateYTemp  + '%) scale(' + recruitZoomSizeTemp  + ')'});
    } else {
      recruitElem.css({transform: 'translate(0, ' + recruitTranslateY  + '%) scale(' + recruitZoomSize  + ')'});
    }
  }
});



// 電話番号リンク
if (navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/)) {
  $(function() {
    $('.js-tellink').each(function() {
      var str = $(this).html();

      if ($(this).children().is('img')) {
        $(this).html($('<a>').attr('href', 'tel:' + $(this).children().attr('alt').replace(/[^0-9]/g, '')).append(str + '</a>')); //対象文字列内から数字だけ取り出してhrefにセット
      } else {
        $(this).html($('<a>').attr('href', 'tel:' + $(this).text().replace(/[^0-9]/g, '')).append(str + '</a>')); //対象文字列内から数字だけ取り出してhrefにセット
      }
    });
  });
}
